/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app        = require('mag-app'),
    keys       = require('stb-keys'),
    Page       = require('stb-component-page'),
    Button     = require('spa-component-button'),
    Grid       = require('spa-component-grid'),
    List       = require('mag-component-list'),
    LayoutList = require('mag-component-layout-list'),
    render     = require('../modules/apps.render'),
    page       = new Page({$node: window.pageMain, className: 'page-main', focusable: false}),
    menuData   = app.data.profile.menu,
    $time      = document.getElementById('pmTime'),
    monthList  = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ],
    dayList = [
        gettext('Sunday'),
        gettext('Monday'),
        gettext('Tuesday'),
        gettext('Wednesday'),
        gettext('Thursday'),
        gettext('Friday'),
        gettext('Saturday')
    ],
    gridList        = [],
    gridListIndex   = 0,
    list            = null,
    monthDayCurrent = 0,
    btnArrowLeft, btnArrowRight, lastActiveComponent,
    menuModal, appsCount, $date, $month, $day, gridCurrentItem;


if ( MODE === 'PORTAL' ) {
    $date = document.getElementById('pmDate');
    $month = $date.children[0];
    $day = $date.children[1];
}

// TODO: update time if the launcher is active
function setTime () {
    var time  = new Date(),
        hours = time.getHours(),
        mins  = time.getMinutes(),
        monthDay, month, day;

    if ( MODE === 'PORTAL' ) {
        monthDay = time.getDate();

        // new day check
        if ( monthDayCurrent !== monthDay ) {
            month = time.getMonth();
            day   = time.getDay();
            $month.innerText = monthList[month];
            $day.innerText   = monthDay + ' ' + dayList[day];
            monthDayCurrent = monthDay;
        }
    }

    $time.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
}


function focusGrid ( direction ) {
    if ( direction === keys.right ) {
        if ( gridListIndex < gridList.length - 1 ) {
            gridCurrentItem.$node.style.visibility = 'hidden';
            gridCurrentItem = gridList[++gridListIndex];
            gridCurrentItem.focus();
            gridCurrentItem.$node.style.visibility = 'inherit';
        }
    }

    if ( direction === keys.left ) {
        if ( gridListIndex > 0 ) {
            gridCurrentItem.$node.style.visibility = 'hidden';
            gridCurrentItem = gridList[--gridListIndex];
            gridCurrentItem.focus();
            gridCurrentItem.$node.style.visibility = 'inherit';
        }
    }

    if ( gridListIndex > 0 ) {
        btnArrowLeft.show();
    } else {
        btnArrowLeft.hide();
    }

    if ( gridListIndex < gridList.length - 1 ) {
        btnArrowRight.show();
    } else {
        btnArrowRight.hide();
    }
}


function lockGridItem ( error ) {
    var $focusItem, focusItemData;

    if ( !error ) {
        $focusItem    = gridCurrentItem.$focusItem;
        focusItemData = $focusItem.data;
        gridCurrentItem.data[$focusItem.y][$focusItem.x].locked = focusItemData.locked = !focusItemData.locked;

        gridCurrentItem.renderItem(gridCurrentItem.$focusItem, focusItemData);
        $focusItem.classList.add('focus');
    }
}


function createParentControl () {
    return new LayoutList({
        size: 1,
        focusIndex: 0,
        data: [
            {
                items: [
                    {
                        value: ' ',
                        className: 'theme-icon theme-icon-rc-f2'
                    },
                    {
                        value: gettext('Parent control')
                    }
                ],
                click: function () {
                    core.taskManager.lockApp(gridCurrentItem.$focusItem.data, function ( error ) {
                        lockGridItem(error);
                        menuModal.hide();
                    });
                }
            }
        ],
        events: {
            keydown: function ( event ) {
                LayoutList.prototype.defaultEvents.keydown.call(this, event);
                if ( event.code === keys.f2 ) {
                    core.taskManager.lockApp(gridCurrentItem.$focusItem.data, lockGridItem);
                } else if ( event.code === keys.back || event.code === keys.menu ) {
                    event.stop = true;
                    menuModal.hide();
                }
            },
            blur: function () {
                menuModal.hide();
            }
        }
    });
}


function createMenu () {
    page.add(
        list = new List({
            $node: window.pmGroupList,
            className: 'app-menu',
            size: appsCount || 1,
            data: appsCount ? menuData : [{name: 'no apps'}],
            render: function ( $item, data ) {
                var $body = document.createElement('div');

                $item.className = 'menu-item item';
                // clear
                $item.innerText = null;

                if ( data ) {
                    $item.$title = document.createElement('div');
                    $body.className = 'menu-item__body';
                    $item.$title.className = 'menu-item__title theme-launcher-color';

                    $body.style.backgroundImage = 'url("' + data.icons + '")';
                    $item.$title.innerText = data.name;

                    $body.appendChild($item.$title);
                    $item.appendChild($body);
                }
            },
            focusIndex: 0,
            type: List.prototype.TYPE_HORIZONTAL,
            cycle: false,
            events: {
                keydown: function ( data ) {
                    if ( data.code === keys.down ) {
                        // leave
                        gridCurrentItem.focus();
                    } else {
                        // left/right
                        switch ( data.code ) {
                            case keys.up:
                            case keys.down:
                            case keys.right:
                            case keys.left:
                            case keys.pageUp:
                            case keys.pageDown:
                            case keys.home:
                            case keys.end:
                                // cursor move only on arrow keys
                                this.move(data.code);
                                break;
                            case keys.back:
                                if ( PLATFORM !== 'MAG' ) {
                                    window.top.platformApi.exit();
                                }
                                break;
                            case keys.ok:
                                break;
                        }
                    }
                },
                'click:item': function ( event ) {
                    var self  = this,
                        $prev = this.$focusItem;

                    if ( event.event && typeof event.event.button !== 'undefined' && event.event.button === 0 ) {
                        // native click
                        this.focus();

                        self.emit('focus:item', {
                            $prev: $prev,
                            $curr: self.$focusItem
                        });
                    }
                },
                'focus:item': function ( event ) {
                    if ( this === page.activeComponent ) {
                        if ( event.$prev ) {
                            event.$prev.firstChild.firstChild.classList.remove('active');
                            event.$curr.firstChild.firstChild.classList.add('active');
                        }

                        if ( gridCurrentItem ) {
                            gridCurrentItem.$node.style.visibility = 'hidden';
                        }

                        gridCurrentItem = gridList[gridListIndex = event.$curr.data.offset];
                        gridCurrentItem.$node.style.visibility = 'inherit';

                        if ( gridListIndex > 0 ) {
                            btnArrowLeft.show();
                        } else {
                            btnArrowLeft.hide();
                        }

                        if ( gridListIndex < gridList.length - 1 ) {
                            btnArrowRight.show();
                        } else {
                            btnArrowRight.hide();
                        }
                    }

                    if ( event.$prev ) {
                        event.$prev.firstChild.classList.remove('theme-focus');
                    }

                    event.$curr.firstChild.classList.add('theme-focus');
                },
                blur: function () {
                    this.$focusItem.firstChild.firstChild.classList.remove('active');
                },
                focus: function () {
                    this.$focusItem.firstChild.firstChild.classList.add('active');
                }
            }
        })
    );
}


function createAppsGrid () {
    menuData.forEach(function ( group, pageIndex ) {
        group.apps.forEach(function ( groupPage ) {
            var grid = new Grid({
                className: 'grid',
                data: groupPage,
                render: render,
                cycleX: false,
                cycleY: false,
                events: {
                    focus: function () {
                        window.pmItemDesc.innerText = this.$focusItem ? this.$focusItem.data.description : '';

                        if ( list !== null ) {
                            list.focusIndex(pageIndex);
                        }

                        console.log('focus grid: ' + gridListIndex);
                    },
                    'focus:item': function ( event ) {
                        window.pmItemDesc.innerText = event.$curr.data.description;
                    },
                    'click:item': function ( data ) {
                        gridCurrentItem.blur();

                        core.taskManager.runApp({
                            visible: true,
                            config: data.$item.data,
                            onerror: function ( error ) {
                                if ( core.notify ) {
                                    if ( error === 0 ) {
                                        core.notify({
                                            title: gettext('Network status: offline'),
                                            icon: 'info'
                                        });
                                    } else {
                                        core.notify({
                                            title: gettext('Service not available, try later'),
                                            icon: 'info'
                                        });
                                    }
                                }
                            }
                        }, true);
                    },
                    overflow: function ( data ) {
                        var index, size;

                        if ( data.direction === keys.up && list !== null ) {
                            list.focus();
                        }

                        if ( data.direction === keys.down ) {
                            if ( this.$focusItem && this.$focusItem.parentNode.nextSibling ) {
                                // if we not at the bottom already, find the last disabled item
                                for ( index = 0, size = this.data[1].length; index < size; ++index ) {
                                    if ( this.data[1][index].disable ) {
                                        break;
                                    }
                                }

                                this.focusItem(this.map[1][index - 1]);
                            }
                        } else if ( data.direction === keys.left || data.direction === keys.right ) {
                            focusGrid(data.direction);
                        }
                    },
                    cycle: function ( data ) {
                        if ( data.direction === keys.up ) {
                            list.focus();
                        }
                    }
                }
            });

            grid.addListener('keydown', function ( data ) {
                var ModalMessage;

                if ( data.code === keys.menu ) {
                    ModalMessage = require('mag-component-modal');

                    if ( !menuModal ) {
                        page.add(menuModal = new ModalMessage({
                            title: gettext('Actions'),
                            events: {
                                show: function () {
                                    this.children[0].focus();
                                },
                                hide: function () {
                                    lastActiveComponent = gridCurrentItem;
                                    gridCurrentItem.focus();
                                }
                            },
                            children: [createParentControl()]
                        }));

                        menuModal.$node.firstChild.className = 'alignBox';
                    }

                    menuModal.show();
                    menuModal.focus();
                } else if ( data.code === keys.f2 && PLATFORM !== 'WEBOS' ) {
                    core.taskManager.lockApp(gridCurrentItem.$focusItem.data, lockGridItem);
                } else if ( data.code === keys.back ) {
                    if ( PLATFORM !== 'MAG' ) {
                        window.top.platformApi.exit();
                    }
                }
            });

            window.pmGrid.appendChild(grid.$node);
            gridList.push(grid);
        });
    });

    gridCurrentItem = gridList[gridListIndex];

    if ( gridList.length < 2 ) {
        btnArrowRight.hide();
    }

    if ( gridList.length > 0 ) {
        gridCurrentItem.$node.style.visibility = 'inherit';
    }
}


function fill () {
    appsCount = menuData.length;

    page.add(
        btnArrowLeft = new Button({
            $node: window.pmArrowLeft,
            className: 'arrow__button',
            events: {
                click: function () {
                    focusGrid(keys.left);
                }
            }
        }),
        btnArrowRight = new Button({
            $node: window.pmArrowRight,
            className: 'arrow__button',
            events: {
                click: function () {
                    focusGrid(keys.right);
                }
            }
        })
    );

    if ( MODE !== 'PORTAL' && appsCount > 1 ) {
        createMenu();
    }

    createAppsGrid();

    btnArrowLeft.hide();

    // apply logo
    window.pmLogo.style.backgroundImage = 'url("' + app.data.profile.logo + '")';
    if ( app.data.profile.logoAlign ) {
        window.pmLogo.className = app.data.profile.logoAlign;
        $time.className = 'reverse-' + app.data.profile.logoAlign;
    }

    setTime();

    if ( PLATFORM === 'SMARTTV' ) {
        // workaround to display time correctly for smarttv devices
        setTimeout(function () {
            $time.style.display = 'none';
        }, 0);

        setTimeout(function () {
            /* eslint no-unused-expressions: 0 */
            // force render
            $time.offsetHeight;
            $time.style.display = '';
        }, 1000);
    }

    setInterval(setTime, 1000);
}


core.addListener('blur', function () {
    lastActiveComponent = page.activeComponent;

    if ( lastActiveComponent ) {
        lastActiveComponent.blur();
    }
});

core.addListener('focus', function () {
    gridCurrentItem.focus();
});

page.addListener('show', function show () {
    if ( gridList.length > 0 ) {
        gridCurrentItem.focus();
    }
});

fill();

// public
module.exports = page;
